import { render, staticRenderFns } from "./OrganisationSelector.vue?vue&type=template&id=0da1382f&scoped=true"
import script from "./OrganisationSelector.vue?vue&type=script&lang=js"
export * from "./OrganisationSelector.vue?vue&type=script&lang=js"
import style0 from "./OrganisationSelector.vue?vue&type=style&index=0&id=0da1382f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da1382f",
  null
  
)

export default component.exports